var React = require('react');

function Info (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.5 16C12.6421 16 16 12.6421 16 8.5C16 4.35786 12.6421 1 8.5 1C4.35786 1 1 4.35786 1 8.5C1 12.6421 4.35786 16 8.5 16Z","stroke":"#898786","strokeWidth":"1.5","key":0}),React.createElement("path",{"d":"M7.84999 11.9992V7.94922H9.19999V11.9992H7.84999ZM7.79999 6.69922V5.44922H9.24999V6.69922H7.79999Z","fill":"#898786","key":1})]);
}

Info.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = Info;

Info.default = Info;
